import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import ReviewModal from '../ReviewModal';
import Button from '../../UI/Button';

import { IHistoryBookingItem } from './interface';
import bemClassName from '../../utils/bem';

import './index.scss';

const historyBookingItem = bemClassName('history-booking-item');

const HistoryBookingItem: React.FC<IHistoryBookingItem> = ({ data }) => {
  const [isOpenModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    if (!data.review) {
      setOpenModal(true);
    }
  };

  const handleCloseModal = (event: MouseEvent) => {
    event?.stopPropagation();
    event?.preventDefault();
    setOpenModal(false);
  };
  return (
    <div
      className={historyBookingItem({
        cancelled: data.statusBooking === 'Отменено',
      })}>
      <Link to={`/catalog/${data.city}/${data.id}/`} className={historyBookingItem('link')}>
        {data && data.photos && data.photos['298x298'] && (
          <picture className={historyBookingItem('image')}>
            <source
              type="image/webp"
              srcSet={`${data.photos?.['600x348'][0]} ${data.photos?.['1200x696'][0]} 2x, ${data.photos?.['1800x1044'][0]} 3x`}
            />
            <img
              className={historyBookingItem('image')}
              src={`${data.photos?.['298x298'][0]}`}
              srcSet={`${data.photos?.['596x596'][0]} 2x, ${data.photos?.['894x894'][0]} 3x`}
              alt=""
            />
          </picture>
        )}
        <div className={historyBookingItem('title')}>
          <h4 className={historyBookingItem('city')}>{data.city}</h4>
          <p className={historyBookingItem('address')}>{data.address}</p>
        </div>
      </Link>
      <div className={historyBookingItem('info-wrap')}>
        <div className={historyBookingItem('info')}>
          <p className={historyBookingItem('description')}>Дата бронирования</p>
          <p className={historyBookingItem('text')}>{data.dateBooking}</p>
        </div>
        <div className={historyBookingItem('info')}>
          <p className={historyBookingItem('description')}>Статус бронирования</p>
          <p className={historyBookingItem('text')}>{data.statusBooking}</p>
        </div>
      </div>
      <div className={historyBookingItem('review')}>
        <Button
          text="Оставить отзыв"
          disable={data.review}
          transparent
          handleExternal={handleOpenModal}
        />
        {data.review && <p className={historyBookingItem('review-text')}>Вы уже оставили отзыв</p>}
        <ReviewModal
          id={data.id ?? 0}
          locationLink="#"
          photos={data.photos}
          city={data.city ?? ''}
          address={data.address ?? ''}
          handleClose={handleCloseModal}
          open={isOpenModal}
        />
      </div>
    </div>
  );
};

export default HistoryBookingItem;
